export default __webpack_public_path__ + "static/media/inProgressMeter.34e273d4.svg";